export default function (apiService) {
  return {
    install(Vue) {
      Vue.prototype.$api = apiService;
    },
  };
}
